import clsx from 'clsx';

import EditableFieldRawHtml from '~components/generic/editable-field/components/EditableFieldRawHtml';
import EditableField from '~components/generic/editable-field/EditableField/EditableField';
import useDynamicTextReplacement from '~hooks/useDynamicTextReplacement';
import { IEntityComponentProps } from '~interfaces/props';

export default function ModuleHtmlInline({ data, editing, className, onChange, origData }: IEntityComponentProps) {
  const { replace } = useDynamicTextReplacement();

  if (!data) {
    return null;
  }

  // raw fields
  const entityType = data.type;
  const title = data.attributes.field_title?.value || '';
  const hideTitle = data.attributes.field_hide_title || false;
  const htmlCode = data.attributes.field_html_source_code || '';

  const clsModule = clsx({ ...className.module }, 'relative htmlcontent');
  const clsContainer = clsx({ ...className.container }, 'px-0 relative');

  return (
    <div className={clsModule} id={origData}>
      <div className={clsContainer}>
        <div className="c-module__header row">
          <div className="col col-12">
            <EditableField
              hide={hideTitle}
              entityType={entityType}
              fieldName="attributes.field_title.value"
              data={title}
              editing={editing}
              onChange={onChange}
            />
          </div>
        </div>
        <div className="c-module__content row flex-wrap">
          <div className="col col-12">
            <EditableFieldRawHtml
              entityType={entityType}
              fieldName="attributes.field_html_source_code"
              data={htmlCode}
              editing={editing}
              onChange={onChange}
              replaceFn={replace}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
